<app-loading *ngIf="loading" width="36" [show]="true"></app-loading>
<ng-container *ngIf="!loading">
  <div *ngIf="filter" class="filter">
    <div
      *ngIf="filter.icon"
      [ngStyle]="{ backgroundImage: 'url(' + filter.icon + ')' }"
      class="search-icon"
    ></div>
    <input
      type="text"
      name="filter"
      [placeholder]="filter.placeholder | translate"
      (keyup)="filterTable($event)"
    />
  </div>
  <div class="table">
    <div class="table-header">
      <div class="table-cell">
        <app-checkbox
          class="select"
          [checked]="isAllSelected()"
          (click)="toggleSelectAll()"
          [value]="items"
          [toCheck]="itemsSelected"
        >
        </app-checkbox>
      </div>
      <div
        class="table-cell {{ col.id }}"
        *ngFor="let col of columns"
        (click)="sortTable($event, col.id)"
      >
        {{ col.label | translate }}
        <span class="arrow"></span>
      </div>
    </div>
    <div class="table-body">
      <p class="no-data" *ngIf="noData">
        {{
          noDataMessage || 'No ' + entityName + (noData ? ' found' : '')
            | translate
        }}
      </p>
      <div
        class="table-row"
        *ngFor="let item of pageItems"
        [class.clickable]="clickable"
      >
        <div *ngIf="selectable" class="table-cell checkbox">
          <app-checkbox
            [value]="item"
            [checked]="item.selected"
            (onChange)="checkboxClick(item)"
          >
          </app-checkbox>
        </div>
        <div
          (click)="clickable && tableRowClick(item)"
          class="table-cell {{ col.id }}"
          *ngFor="let col of columns"
          [class.is-admin]="getIsAdmin(item, col.id)"
        >
          {{ item[col.id] }}
          <span *ngIf="isMe(item, col.id)">({{ 'me' | translate }})</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
